export default "__VITE_ASSET__CxdDliZU__"